import { useState } from "react";
import { withErrorHandling } from "@entrilia/shared/api/axiosHelper";
import { useNotificationContext } from "@entrilia/shared/contexts/NotificationContext";
import { logError } from "@entrilia/shared/logging";
import { downloadFileFromUrl } from "@entrilia/shared/services/downloadFile";
import adminApi from "../../../../api/adminApi";

const getInvoiceDocumentsDownload = withErrorHandling(adminApi.getInvoiceDocumentsDownload);

const useInvoiceDocumentsDownload = () => {
  const { sendNotification, sendNotificationError } = useNotificationContext();

  const [downloading, setDownloading] = useState(false);

  const downloadInvoiceDocuments = async (invoiceIds: string[]) => {
    setDownloading(true);
    const [download, error] = await getInvoiceDocumentsDownload(invoiceIds, "invoices.zip");
    setDownloading(false);

    if (error) {
      logError(error, "[useInvoiceDocumentsDownload] getInvoiceDocumentsDownload");
      sendNotificationError(error.message);
      return;
    }

    const { downloadUrl, includedDocumentCount, requestedInvoiceCount } = download;

    if (includedDocumentCount < requestedInvoiceCount) {
      sendNotification(
        `Downloading ${includedDocumentCount} of ${requestedInvoiceCount} invoices — the rest have no document attached.`
      );
    }

    await downloadFileFromUrl(downloadUrl);
  };

  return { downloading, downloadInvoiceDocuments };
};

export default useInvoiceDocumentsDownload;
